import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from '@ed---interne/ng-uui-components';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [CommonModule, SharedModule, ButtonModule],
})
export class HomeComponent {
    public throwTestError(): void {
        throw new Error('Sentry Test Error');
    }
}
